export default "__VITE_ASSET__DiaJI$dn__"